/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Button } from './Button';
import {
    ButtonFromJSON,
    ButtonFromJSONTyped,
    ButtonToJSON,
    ButtonToJSONTyped,
} from './Button';

/**
 * 
 * @export
 * @interface CopyButtonResponse
 */
export interface CopyButtonResponse {
    /**
     * The copied buttons in the target domain
     * @type {Array<Button>}
     * @memberof CopyButtonResponse
     */
    buttons: Array<Button>;
}

/**
 * Check if a given object implements the CopyButtonResponse interface.
 */
export function instanceOfCopyButtonResponse(value: object): value is CopyButtonResponse {
    if (!('buttons' in value) || value['buttons'] === undefined) return false;
    return true;
}

export function CopyButtonResponseFromJSON(json: any): CopyButtonResponse {
    return CopyButtonResponseFromJSONTyped(json, false);
}

export function CopyButtonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyButtonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'buttons': ((json['buttons'] as Array<any>).map(ButtonFromJSON)),
    };
}

export function CopyButtonResponseToJSON(json: any): CopyButtonResponse {
    return CopyButtonResponseToJSONTyped(json, false);
}

export function CopyButtonResponseToJSONTyped(value?: CopyButtonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buttons': ((value['buttons'] as Array<any>).map(ButtonToJSON)),
    };
}

